import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { flow, get, map, getOr, first } from 'lodash/fp';

import loading from '../../actions/loading';
import loaded from '../../actions/loaded';
import InstallationSummaryModal from './InstallationSummaryModal';
import updateInstallationPricing from '../../actions/getInstallationPricing';
import globalError from '../../actions/globalError';

import getItemsWithPurchaseOptionIn from '../../helpers/mandi/getItemsWithPurchaseOptionIn';
import getItemsWithSurcharge from '../../helpers/mandi/getItemsWithSurcharge';

const mapStateToProps = ({ estimateBuilder }, { designId }) => {
  const textOptInNumber = flow(
    getOr('{}', `entities.estimates.byId.${designId}.attributes.customer`),
    JSON.parse,
    get('phones'),
    first,
    getOr('', 'number'),
  )(estimateBuilder);

  const selectedProducts = flow(
    get('entities.items.byId'),
    getItemsWithPurchaseOptionIn(['product-and-install'], designId),
  )(estimateBuilder);

  const selectedLeafItems = flow(
    get('entities.items.byId'),
    getItemsWithPurchaseOptionIn(['product-and-install'], designId),
    map('itemId'),
  )(estimateBuilder);

  const selectedProductOnly = flow(
    get('entities.items.byId'),
    getItemsWithPurchaseOptionIn(['product-only'], designId),
  )(estimateBuilder);

  const haulAwayCount = parseInt(flow(
    get('mandi.designs'),
    getItemsWithSurcharge('windowHaul', designId),
    getOr(0, 'value'),
  )(estimateBuilder));

  const removalCount = parseInt(flow(
    get('mandi.designs'),
    getItemsWithSurcharge('windowRemoval', designId),
    getOr(0, 'value'),
  )(estimateBuilder));

  let adjustmentCount = parseInt(flow(
    get('mandi.designs'),
    getItemsWithSurcharge('windowAdjustment', designId),
    getOr(0, 'value'),
  )(estimateBuilder));

  if (adjustmentCount === 0) {
    // Some older estimates may have 'windowadjustment' instead of 'windowAdjustment'
    adjustmentCount = parseInt(flow(
      get('mandi.designs'),
      getItemsWithSurcharge('windowadjustment', designId),
      getOr(0, 'value'),
    )(estimateBuilder));
  }

  return {
    designId,
    selectedProducts,
    selectedLeafItems,
    selectedProductOnly,
    textOptInNumber,
    haulAwayCount,
    removalCount,
    adjustmentCount,
  };
};
const mapDispatchToProps = dispatch => ({
  ...bindActionCreators({
    updateInstallationPricing,
  }, dispatch),
  setLoading: value => (value
    ? dispatch(loading())
    : dispatch(loaded())
  ),
  globalError: err => dispatch(globalError({ err })),
});
export default connect(mapStateToProps, mapDispatchToProps)(InstallationSummaryModal);
